import { ApolloLink, Observable } from '@apollo/client';
import { print } from 'graphql';
import { Client, ClientOptions, createClient } from 'graphql-sse';

import { QP_QUERY_URI } from '@constants/config';
import { APPOINTMENT_TOKEN } from '@constants/storageKeys';
import { EventTypes, emitter } from '@services/emitter';

const getAppointmentToken = () => localStorage.getItem(APPOINTMENT_TOKEN);

class SSELink extends ApolloLink {
  private client: Client;

  constructor(options: ClientOptions) {
    super();
    this.client = createClient(options);
  }

  public request(
    operation: ApolloLink.Operation
  ): Observable<ApolloLink.Result> {
    return new Observable((sink) => {
      return this.client.subscribe<ApolloLink.Result>(
        {
          query: print(operation.query),
          variables: operation.variables,
          operationName: operation.operationName,
          extensions: operation.extensions,
        },
        {
          next: sink.next.bind(sink) as never,
          complete: sink.complete.bind(sink),
          error: sink.error.bind(sink),
        }
      );
    });
  }
}

export const sseLink = new SSELink({
  url: QP_QUERY_URI,
  headers: () => {
    const appointmentToken = getAppointmentToken();
    return {
      authorization: '',
      ...(appointmentToken ? { 'x-appointment-token': appointmentToken } : {}),
    };
  },
  on: {
    connected: (reconnected) => {
      if (reconnected) {
        emitter.emit(EventTypes.RemoteConnectionRestored);
      }
    },
  },
});
